<template>
  <!-- TODO: possibly get rid of appInner -->
  <div id="appInner" class="test">
    <component :is="this.$route.meta.layout || 'div'">
      <router-view />
    </component>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { getRequest } from "./utils/api";

export default defineComponent({
  name: "App",
  async mounted() {
    const token = localStorage.getItem("token");

    if (token) {
      const result = await getRequest("whoami", token);

      // a failed lookup (expired/invalid token) comes back as {detail: "..."} with no
      // username, not a thrown Error — getRequest never rejects, it always resolves JSON.
      if (!result?.username) {
        console.log("The user token is invalid");
        localStorage.removeItem("token");
        return;
      }

      // otherwise the token is valid
      this.$store.dispatch("logInWithToken", token);
      this.$store.dispatch("getUser");

      if (result.must_change_password && this.$route.name !== "ChangePassword") {
        this.$router.push({ name: "ChangePassword" });
      }
    }
  },
});
</script>

<style>
/* Global styles go here */

/* CSS variables that can be used in other places */
:root {
  --var-color-almost-black: #2c3e50;
  --var-color-blue-dark: #0f4284;
  --var-color-blue-mid: #3f679c;
  --var-color-blue-lightest: #F4F7F9;
  --var-color-gray: #878787;
  --var-color-gray-lighter: rgb(236, 240, 245);
  --var-color-green: #8ac38c;
  --var-color-green-light: #badcbb;
  --var-color-green-lighter: #d0e7d0;
  --var-color-teal: #19a3b2;
  --var-color-pink: #f15882;
  --var-color-pink-light: #f9d0db;
  --var-color-pink-lighter: #fdecf1;
}

html,
body {
  overflow: auto;
}

body {
  width: 100vw;
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--var-color-almost-black);
  width: 100%;
  height: 100%;
}

#appInner {
  width: 100%;
  height: 100%;
}

main {
  padding: 5vw;
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 26px;
}

h3 {
  font-size: 24px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: var(--var-color-almost-black);
}

#nav a.router-link-exact-active {
  color: #42b983;
}

ion-icon {
  color: var(--var-color-gray);
}
</style>
